import {useDispatch} from "react-redux";
import {useCallback} from "react";
import {setDataImageGallery} from "../../../redux/modals/modal-image-gallery/actionImageGallery";
import {isEmpty} from "lodash/lang";

const useImageGalleryFn = () => {
    const dispatch = useDispatch();

    // ������� �������, ������� ������������ ������ �������� ���������� ����
    const showModalImg = useCallback((arrObj = []) => {

        if (isEmpty(arrObj)){
            return false;
        }

        // Фильтруем массив, убираем null, undefined и объекты без viewUrl
        const validAttachments = arrObj.filter(item => 
            item && 
            typeof item === 'object' && 
            item.viewUrl
        );

        // Если после фильтрации ничего не осталось, не показываем модалку
        if (validAttachments.length === 0) {
            return false;
        }

        _setData({
            modalShow: true,
            attachments: validAttachments
        })
    }, [dispatch]);

    const closeModalImg = useCallback(() => {
        _setData({modalShow: false, attachments: []})
    }, [dispatch]);

    const _setData = (obj) => {
        dispatch(setDataImageGallery(obj));
    }

    return {showModalImg, closeModalImg};
}
export default useImageGalleryFn
